import React from 'react';
import { Entity, LabelGraphics, ModelGraphics, PolygonGraphics } from 'resium';
import * as Cesium from 'cesium';
import * as DOMPurify from 'dompurify';
const NO_FLY_ZONE_MODEL_URI = '/safety_signs.glb';
function NoFlyZoneEntity({ noFlyZone }) {
    DOMPurify.setConfig({ ALLOWED_TAGS: [] });
    const description = [`<table><tr><td>Name</th><td>${DOMPurify.sanitize(noFlyZone.name)}</td></tr>`, '</table>'];
    const points = noFlyZone.area?.at(0)?.slice(0, -1);
    if (!points) {
        return React.createElement(React.Fragment, null);
    }
    const lat = points.reduce((prev, curr) => prev + curr[1], 0) / points.length;
    const lng = points.reduce((prev, curr) => prev + curr[0], 0) / points.length;
    return (React.createElement(Entity, { position: Cesium.Cartesian3.fromDegrees(lng, lat, 0), name: "No-fly zone", description: description.join('') },
        React.createElement(LabelGraphics, { text: noFlyZone.name, scale: 0.8, showBackground: true, backgroundColor: Cesium.Color.MEDIUMORCHID.withAlpha(0.5), backgroundPadding: new Cesium.Cartesian2(30, 10), eyeOffset: new Cesium.Cartesian3(0, 4, 0), horizontalOrigin: Cesium.HorizontalOrigin.CENTER, verticalOrigin: Cesium.VerticalOrigin.BOTTOM }),
        React.createElement(PolygonGraphics, { hierarchy: { positions: Cesium.Cartesian3.fromDegreesArray(points.flatMap((e) => e)), holes: [] }, material: Cesium.Color.MEDIUMORCHID.withAlpha(0.25), extrudedHeight: 0, outline: true, outlineWidth: 5, outlineColor: Cesium.Color.MEDIUMORCHID }),
        React.createElement(ModelGraphics, { uri: NO_FLY_ZONE_MODEL_URI, scale: 1 / 5, maximumScale: 25, minimumPixelSize: 32 })));
}
export default React.memo(NoFlyZoneEntity);
